import React from "react";

type PropsType = {
  type: "submit" | "button";
  color: "primary" | "secondary";
  text: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};
export default function CustomButton(props: PropsType) {
  const { color, type, text, onClick } = props;
  return (
    <button type={type} className={`button button_${color}`} onClick={onClick}>
      {text}
    </button>
  );
}
